import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { useRfpOneProfessional } from '@/hooks/pages/rfp/professional/useRfpOneProfessional';
import { RfpProfessionalOnePage } from '@/pages/rfp/professional/RfpProfessionalOne/RfpProfessionalOnePage';
import { RfpProfessionalOneSkeleton } from '@/pages/rfp/professional/RfpProfessionalOne/RfpProfessionalOneSkeleton';
import { myPagePath } from '@/utils/router/links';
/**
 * コンサルタント：案件詳細ページのコンテンツを取得するコンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalOne = (props) => {
    const { profile } = props;
    // 案件詳細データ取得, ページ状態管理
    const { loading, rfp } = useRfpOneProfessional();
    // ローディング表示
    if (loading && !rfp) {
        return _jsx(RfpProfessionalOneSkeleton, {});
    }
    // リダイレクト：案件が存在しない場合
    if (!rfp) {
        return _jsx(CustomRedirect, { to: myPagePath() });
    }
    return _jsx(RfpProfessionalOnePage, { profile: profile, rfp: rfp });
};
